<template>
  <div :class="['router-tabs', { 'is-button': isButton }]">
    <Tabs :model-value="routeFullPath" @update:modelValue="update">
      <slot :current-tab="routeFullPath" />
    </Tabs>
  </div>
</template>

<script lang="ts" setup>
import { computed, provide } from "vue";
import { useRouter } from "vue-router";
import { Tabs } from "tir-components";

const props = defineProps({
  isButton: {
    type: Boolean,
    default: false,
  },
});

provide("routerTabsIsButton", props.isButton);

const router = useRouter();
const routeFullPath = computed(() => router.currentRoute.value.fullPath);

const update = (value: string) => {
  router.push({ path: value });
};
</script>

<style lang="scss">
.router-tabs {
  &.is-button {
    .tabs {
      border-bottom: none;
      gap: 0.5rem;
    }
  }
}
</style>
